let filterMenuContainerElement = null
let filterMenuTriggerElement = null

export const setFilterMenuContainerElement = (element) => {
  filterMenuContainerElement = element
}

export const getFilterMenuContainerElement = () => filterMenuContainerElement

export const setFilterMenuTriggerElement = (element) => {
  filterMenuTriggerElement = element
}

export const getFilterMenuTriggerElement = () => filterMenuTriggerElement
